'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024 from "./presto.types$-Envelope-Title$.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$1(outer) {
  this.bVa = null;
  this.bV8 = null;
  this.bV9 = false;
  this.bV6 = null;
  this.bV7 = false;
  this.bVb = false;
  this.bVc = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bVa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$1 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$1 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$1;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$1() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$1 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$1 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bVa;
});
$p.t = (function() {
  if ((!this.bV9)) {
    this.bV8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("title", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bV9 = true;
  }
  return this.bV8;
});
$p.ag = (function() {
  if ((!this.bV7)) {
    this.bV6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEnvelope$002dTitle$0024.$m_Lpresto_types$EnvelopeTitle$().cJ5(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bV7 = true;
  }
  return this.bV6;
});
$p.v = (function() {
  if ((!this.bVc)) {
    this.bVb = false;
    this.bVc = true;
  }
  return this.bVb;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$1, "presto.pages.envelopes.EnvelopesView$$anon$1", ({
  WG: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$1 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$1 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$1.js.map
